// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Raleway:400,500,600,700,800);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page{width:100%;padding:0}
.home-page__container{display:flex;flex-direction:column;align-items:center;justify-content:center;box-sizing:border-box;width:100%;height:100%;padding:0;overflow:auto;color:var(--font-color);font-size:14px}
.home-page__header{position:absolute;top:0;display:flex;align-items:center;justify-content:space-between;width:100%;padding:24px;font-size:16px}
.home-page__header .user-menu__user-icon{fill:var(--space-cadet)}
.home-page__header .user-menu__overlay{position:inherit}
.home-page__title{color:var(--space-cadet);font-weight:900;font-size:46px;font-family:var(--secondary-font)}
.home-page__title-section{align-items:center;padding:12px;text-align:center}
.home-page__section{position:relative;display:flex;flex-direction:column;align-items:center;justify-content:space-between;width:80%;min-height:500px;background-color:#fff;border-radius:6px}
.home-page__section__header{height:2em}
.home-page__section .button{position:absolute !important;top:15px;right:50px}
.home-page__footer{width:70%;text-align:center}
.home-page__footer__contact-support-link{color:var(--electric-indigo)}
.home-page__footer .mail-link{color:var(--electric-indigo);font-weight:bold;text-decoration:none !important}
.home-page__footer p{font-size:14px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
